module.exports = __webpack_public_path__ + "static/media/folder-minus.024767e2.svg";